var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65.275,
    height: 65.229,
    viewBox: "0 0 65.275 65.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.642,
    y1: 0.015,
    x2: 0.618,
    y2: 0.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Corporate_Identity",
    "data-name": "Corporate Identity",
    d: "M53.485,1.514a5.6,5.6,0,0,0-3.963,1.628l-1.395,1.4a1.881,1.881,0,0,0-.162.154l-.7.7a1.88,1.88,0,0,0-.327.417l-3.117,3.4q-.029.035-.056.071l-10.2,10.2L16.835,2.758a3.844,3.844,0,0,0-5.286,0L2.526,11.785a3.827,3.827,0,0,0,0,5.294l.008.008L19.422,33.625,9.042,44.006a1.88,1.88,0,0,0-1.331,1.237L2.071,62.537A1.88,1.88,0,0,0,4.44,64.906l17.295-5.64a1.88,1.88,0,0,0,.955-.718L33.521,47.717l16.37,16.727.008.008a3.827,3.827,0,0,0,5.294,0l9.023-9.023a3.82,3.82,0,0,0,0-5.29L47.657,33.58,58.414,22.824a1.88,1.88,0,0,0,.429-.662l2.32-2.132.008-.008a1.88,1.88,0,0,0,.414-.312l.7-.7a1.88,1.88,0,0,0,.177-.177l1.38-1.38a5.64,5.64,0,0,0,0-7.925L57.444,3.142a5.583,5.583,0,0,0-3.955-1.628Zm0,3.654a1.877,1.877,0,0,1,1.3.632l6.391,6.391a1.664,1.664,0,0,1,0,2.605L59.76,16.222l-.023.023-.09.079L57,18.748,48.229,9.981l2.5-2.741L52.18,5.8a1.87,1.87,0,0,1,1.3-.632Zm-39.289.263L30.908,22.147l-8.82,8.82L19.336,28.26l6.429-6.429-3.722-3.722-6.47,6.474-3.872-3.8,2.609-2.605-3.722-3.715L7.944,17.109,5.2,14.429,14.2,5.435ZM45.221,13.15l2.35,2.35-32.8,32.8-2.35-2.35Zm6.072,6.076,2.7,2.7-32.8,32.8-2.7-2.7ZM45,36.238,61.542,52.781l-8.993,9-2.372-2.417,6.343-6.343L52.8,49.3l-6.3,6.3-4.053-4.139,2.624-2.621-3.722-3.722-2.579,2.575-2.587-2.636L45,36.238ZM10.335,49.322l7.32,7.324L8.03,59.782,7.2,58.943l3.136-9.621Z",
    transform: "translate(-0.734 -1.014)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPens);
export default __webpack_public_path__ + "static/media/pens.51f1d4a10d634ea8f5c8b6735856df57.svg";
export { ForwardRef as ReactComponent };